import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable} from 'epic-alt-utils/index';

@seamlessImmutable
class TutorialStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.state = Immutable({
            tutorialsData: null
        });
    }
}

export default alt.createStore(TutorialStore, 'TutorialStore');
